import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/theme-green/index1.css'; // 浅绿色主题 九州代驾主题色
// import './assets/css/theme-green/ling.css'; // 羚师傅代驾主题色
import './assets/css/icon.css';
// import 'babel-polyfill';
import {
    post
} from './utils/http';
import {
    config
} from './utils/config';


// 陕西羚师傅软件需要自己的主题色 开始

// 动态导入一个CSS文件
// function importCSS(href) {
//     return new Promise((resolve, reject) => {
//         const link = document.createElement('link');
//         link.href = href;
//         link.rel = 'stylesheet';
//         link.type = 'text/css';
//         link.onload = () => resolve();
//         link.onerror = () => reject(new Error(`CSS file ${href} didn't load`));
//         document.head.appendChild(link);
//     });
// }

// // 在组件或者其他逻辑中使用
// // 假设你有一个CSS文件 'example.css' 在你的静态文件目录下
// importCSS('/assets/css/theme-green/ling.css').then(() => {
//     console.log('CSS file loaded');
// }).catch(error => {
//     console.error(error.message);
// });


window.configSet = config; // 区分九州代驾还是马上代驾  在public index.js 文件里面用到这个值了


// const cssFile = config.proType == '羚师傅' ? 'ling.css' : 'index1.css';
const cssFile = config.proTheme;


import (`./assets/css/theme-green/${cssFile}`).then((module) => {
    // 创建并插入style标签
    const style = document.createElement('style');
    style.textContent = module.default;
    document.head.appendChild(style);
});
// 陕西羚师傅软件需要自己的主题色 结束

import pages from './components/mine/pages.vue';
import selectPages from './components/mine/selectPages.vue';
import '@/assets/iconfont/iconfont.css';
import global from './utils/global.js';
// import * as voicePromptFun from './utils/voicePrompt';
// 百度语音
import * as bttsFun from './utils/baidu_tts_cors';
// 全局自定义组件 --对话框保存按钮
import submitBtn from './components/common/submitBtn';
import bus from './components/common/bus';
import axios from 'axios'; // AJAX封装类
// 全部路由数据
import { allNav } from './router/routerData';

// 引入新订单需要协助指派音频文件
import needDriverAudio from '@/assets/need-driver.mp3'

// 引入导出表格数据方法
import exportTable from '@/utils/exportTable.js'
//引入上传图片方法
import uploadImage from '@/utils/uploadImage.js'


// 导出表格数据全局方法
Vue.prototype.$exportTable = exportTable;
Vue.prototype.$uploadImage = uploadImage; // 上传图片方法
let audio = null;
Vue.prototype.$driverAlert = ''; // 司机预警










// const synth = window.speechSynthesis;
// const msg = new SpeechSynthesisUtterance();
//
// // 语音播报方法
// Vue.prototype.$handleSpeak = function(text) {
//     console.log(text);
//     msg.text = text;     // 文字内容
//     msg.lang = "zh-CN";  // 使用的语言:中文
//     msg.volume = 1;      // 声音音量：1
//     msg.rate = 1.5;        // 语速：1
//     msg.pitch = 1;       // 音高：1
//     synth.speak(msg);    // 播放
// }

Vue.component("submitBtn", submitBtn); //全局自定义组件 --对话框保存按钮

Vue.prototype.$btts = bttsFun.btts; //百度语音提醒
// Vue.prototype.voicePrompt = voicePromptFun.voicePrompt; //语音提醒

Vue.prototype.global = global;


Vue.component('pages', pages);
Vue.component('selectPages', selectPages);
Vue.prototype.$post = post;
Vue.prototype.config = config;

//地图，三级联动声明      围栏功能
AMap.plugin(['AMap.DistrictSearch', 'AMap.PolyEditor', 'AMap.Map3D']);


Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});




Vue.prototype.$hash_key = function(mode = 'none') {


    //hash创造

    var time = Math.round(new Date() / 1000) + Number(sessionStorage.getItem('time_difference'));


    time = time.toString();


    var hash = hex_md5(hex_md5(time + config.hash_key));


    var num1 = Math.ceil(Math.random() * 9);
    var num2 = Math.ceil(Math.random() * 9);
    var num3 = Math.ceil(Math.random() * 9);
    var num4 = Math.ceil(Math.random() * 9);

    var str = num1.toString() + num2.toString() + num3.toString() + num4.toString() + time.slice(-2, -1) + time.slice(-1) + hash.slice(num1, num1 + 1) + hash.slice(num2, num2 + 1) + hash.slice(num3, num3 + 1) + hash.slice(num4, num4 + 1);

    return str;


};

// 定义全局方法-------拼接socket链接地址
Vue.prototype.$getSocketUrl = function() {


    var socket_url = config.webSocket + 'port=admin&platform=pc&hash_key=' + this.$hash_key() + '&token=' + localStorage.getItem(config.localStorage_token_name) + '&city_tag=' + localStorage.getItem('city_tag');

    return socket_url;


};


var notify, notify_run;

// socket每10秒发送一次心跳
Vue.prototype.$sendPing = () => {
    setInterval(() => {
        global.ws.send(JSON.stringify({
            'ws_mode': 'adminHeartbeat',
            'fd_return': '1'
        }));
    }, 10000);
}


// 定义全局方法-----用来检测司机上线下线状态来弹出提示框
Vue.prototype.$driverState = function(resData, broadcast_value) {
    // console.log(resData, 'resData');
    broadcast_value = JSON.parse(localStorage.getItem('broadcast_value'));


    if (resData.identification == 'driver_online' && resData.header == 'success' && broadcast_value.driver_online && broadcast_value.driver_online != null) {

        // 接收到司机上线数据 app 杀死重新打开，司机为上线
        // this.voicePrompt(resData.msg);
        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 2000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'driver_offline' && resData.header == 'success' && broadcast_value.driver_offline && broadcast_value.driver_offline != null) {

        // 接收到司机下线数据
        // this.voicePrompt(resData.msg);
        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 3000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'need_driver' && resData.header == 'wait' && broadcast_value.need_driver && broadcast_value.need_driver != null) {
        // 接收到待派单数据
        // this.$btts({
        //     tex: '有新订单需要协助指派',
        //     tok: localStorage.getItem('bdToken'),
        //
        // }, {
        //     volume: 0.3,
        //     autoDestory: true,
        //     timeout: 10000,
        //     hidden: false,
        //     onInit: function (htmlAudioElement) {
        //
        //     },
        //     onSuccess: function(htmlAudioElement) {
        //         htmlAudioElement.className = 'baidu'
        //         htmlAudioElement.play()
        //
        //     },
        //     onError: function(text) {
        //
        //     },
        //     onTimeout: function () {
        //
        //     }
        // });
        if (audio != null) {
            audio.pause();
        }
        audio = new Audio();
        audio.src = needDriverAudio;
        // audio.loop = "loop";
        audio.play();


        // this.$handleSpeak('有新订单需要协助指派');
        // this.voicePrompt('有新订单需要协助指派');

        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 2000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'need_legwork_driver' && resData.header == 'wait') {

        // this.voicePrompt(resData.msg);
        this.$btts({
            tex: '有跑腿订单需要协助指派',
            tok: localStorage.getItem('bdToken'),

        }, {
            volume: 0.3,
            autoDestory: true,
            timeout: 10000,
            hidden: false,
            onInit: function(htmlAudioElement) {

            },
            onSuccess: function(htmlAudioElement) {
                htmlAudioElement.className = 'baidu'
                htmlAudioElement.play()

            },
            onError: function(text) {

            },
            onTimeout: function() {

            }
        });
        // this.$handleSpeak('有跑腿订单需要协助指派');
        // 接收到跑腿协助指派
        if (notify_run) {

            notify_run.close();

        }
        notify_run = this.$notify({
            message: '有跑腿订单需要协助指派！！！',
            duration: 0,
            type: 'info',
            offset: 80
        });




    } else if (resData.identification == 'need_inspection_driver' && resData.header == 'wait') {
        // this.voicePrompt(resData.msg);
        this.$btts({
            tex: resData.msg,
            tok: localStorage.getItem('bdToken'),

        }, {
            volume: 0.3,
            autoDestory: true,
            timeout: 10000,
            hidden: false,
            onInit: function(htmlAudioElement) {

            },
            onSuccess: function(htmlAudioElement) {
                htmlAudioElement.className = 'baidu'
                htmlAudioElement.play()

            },
            onError: function(text) {

            },
            onTimeout: function() {

            }
        });
        // this.$handleSpeak(resData.msg);
        // 接收到检车协助指派
        if (notify_run) {

            notify_run.close();

        }
        notify_run = this.$notify({
            message: '有检车订单需要协助指派！！！',
            duration: 0,
            type: 'info',
            offset: 80
        });

    }


};
// 全部导航

router.onReady(() => {

    if (localStorage.getItem('access_token') == null || localStorage.getItem('access_token') == '') {

        localStorage.removeItem('access_token');
        sessionStorage.removeItem('navBar');
        next('/login');
        return;

    }

    // 有权限访问的导航
    let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



    let navList = []

    for (let a = 0; a < allNav.length; a++) {

        for (let i = 0; i < returnNav.length; i++) {

            if (returnNav[i].subs) {
                //   存在二级导航

                for (let j = 0; j < returnNav[i].subs.length; j++) {


                    if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                        navList.push(allNav[a])



                    } else {

                        if (returnNav[i].subs[j].subs) {

                            //   存在三级导航

                            for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                    navList.push(allNav[a])
                                }
                            }

                        }
                    }

                }

            } else {

                if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                    navList.push(allNav[a])

                }

            }



        }


    }

    router.addRoutes([{
        path: '/',
        component: () =>
            import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
        meta: {
            title: '自述文件'
        },
        children: navList
    }])

    next({...to, replace: true })
})

//使用钩子函数对路由进行权限跳转
router.beforeEach(async(to, from, next) => {

    // 九州的项目登录页面没有添加路由，因为在这里添加的路由



    if (to.path == '/login') {

        // 跳转登录页 && token存在 && navBar数据存在

        if (localStorage.getItem('access_token') != null && sessionStorage.getItem('navBar')) {
            // token存在 && navBar数据存在
            ;
            next('/' + JSON.parse(localStorage.getItem('login')).menu);

        } else {

            next();

        }



    } else {
        // 如果跳转非登录页


        if (localStorage.getItem('access_token') != null) {



            //登录状态



            if (sessionStorage.getItem('navBar')) {

                // 存在navBar数据

                next();


            } else {




                // 不存在navBar数据
                axios({
                    method: 'post',
                    url: config.axios_baseURL + '/system/getMenuDetails',
                    data: {
                        admin_role_code: JSON.parse(localStorage.getItem('login')).admin_role_code
                    },
                    headers: {
                        'token': localStorage.getItem(config.localStorage_token_name),
                        'city-tag': localStorage.getItem('city_tag'),
                        'hash-key': Vue.prototype.$hash_key()
                    }
                }).then(res => {

                    // token失效，返回登录页面
                    if (res.data.code == 1001) {
                        localStorage.removeItem('access_token');
                        sessionStorage.removeItem('navBar');
                        next('/login');

                    } else {



                        sessionStorage.setItem('navBar', JSON.stringify(res.data.data));


                        // 有权限访问的导航
                        let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



                        let navList = []

                        for (let a = 0; a < allNav.length; a++) {

                            for (let i = 0; i < returnNav.length; i++) {

                                if (returnNav[i].subs) {
                                    //   存在二级导航

                                    for (let j = 0; j < returnNav[i].subs.length; j++) {

                                        if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                                            navList.push(allNav[a])


                                        } else {

                                            if (returnNav[i].subs[j].subs) {

                                                //   存在三级导航

                                                for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                                    if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                                        navList.push(allNav[a])
                                                    }
                                                }

                                            }
                                        }

                                    }

                                } else {

                                    if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                                        navList.push(allNav[a])

                                    }

                                }



                            }


                        }

                        router.addRoutes([{
                            path: '/',
                            component: () =>
                                import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
                            meta: {
                                title: '自述文件'
                            },
                            children: navList
                        }])

                        next({...to, replace: true })
                    }



                });

            }






        } else {

            if (sessionStorage.getItem('navBar')) {



                // 有权限访问的导航
                let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



                let navList = []

                for (let a = 0; a < allNav.length; a++) {

                    for (let i = 0; i < returnNav.length; i++) {

                        if (returnNav[i].subs) {
                            //   存在二级导航

                            for (let j = 0; j < returnNav[i].subs.length; j++) {

                                if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                                    navList.push(allNav[a])


                                } else {

                                    if (returnNav[i].subs[j].subs) {

                                        //   存在三级导航

                                        for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                            if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                                navList.push(allNav[a])
                                            }
                                        }

                                    }
                                }

                            }

                        } else {

                            if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                                navList.push(allNav[a])

                            }

                        }



                    }


                }

                router.addRoutes([{
                    path: '/',
                    component: () =>
                        import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
                    meta: {
                        title: '自述文件'
                    },
                    children: navList
                }])

            }


            // 未登录状态
            next('/login');



        }


    }


});


new Vue({
    router,
    render: h => h(App),

}).$mount('#app');